
import React, { useState } from "react";
import '../static/form.css';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import { FaEdit, FaSave } from "react-icons/fa"; // Importing icons

const Grooming = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id'); // ✅ Get the value of "id"

  // Initial Pet Data
  const initialPetDetails = {
    id: params.get("id") || "", // Assuming we need an ID to update
    name: params.get("name") || "",
    breed: params.get("breed") || "",
    gender: params.get("gender") || "Male",
    age: params.get("age") || "",
    phone: params.get("phone") || "",
    behaviour: params.get("behaviour") || "",
    vaccinated: params.get("vaccinated") === "true" ? "Yes" : "No",
    neutered: params.get("neutered") === "true" ? "Yes" : "No",
    booking_date: params.get("booking_date") || "",
    booking_time: params.get("booking_time") || "",
    subject: params.get("subject") || "",
    text: params.get("text") || "",
    time: params.get("time") || "",
    ownername: params.get("owner") || "",
    ownerphone: params.get("phone") || "",
    owneremail: params.get("owneremail") || "",
    owneraddress: params.get("owneraddress") || "",
  };

  const [petDetails, setPetDetails] = useState(initialPetDetails);
  const [editableFields, setEditableFields] = useState({}); // Track editable fields
  const [responseMessage, setResponseMessage] = useState("");

  // Handle field edit
  const handleEdit = (field) => {
    setEditableFields((prev) => ({
      ...prev,
      [field]: !prev[field], // Toggle edit mode
    }));
  };

  // Handle input change
  const handleChange = (e, field) => {
    setPetDetails({ ...petDetails, [field]: e.target.value });
  };

  // Handle form submission (update backend)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`/update-pet/${petDetails.id}`, petDetails);
      setResponseMessage("Pet details updated successfully!");
      const updatedPet = response.data.pet; // Grab the updated pet data
       // Build query string to pass pet values
      const queryString = new URLSearchParams(updatedPet).toString();

      // Redirect to PetMessage.js with updated values
      navigate(`/petmessage?${queryString}`);
      
    } catch (error) {
      setResponseMessage("An error occurred. Please try again.");
    }
  };
  return (
    <section className="contact-wrap">
      <form className="contact-form" onSubmit={handleSubmit}>
        
  
        {id === 'Grooming' && (
          <>
          <h2>{id} Information</h2>
            {Object.entries(petDetails).map(([key, value]) => (
              <div className="input-block" key={key}>
                <label>
                  {key.replace(/_/g, " ").toUpperCase()}
                  <span
                    className="edit-icon"
                    onClick={() => handleEdit(key)}
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                  >
                    ✏️
                  </span>
                </label>
                {editableFields[key] ? (
                  <input
                    type="text"
                    value={value}
                    onChange={(e) => handleChange(e, key)}
                    className="form-control"
                  />
                ) : (
                  <p className="display-label">{value}</p>
                )}
              </div>
            ))}
          </>
        )}
  
        <br />
        <div>
          <button type="submit" className="square-button">Confirm</button>
        </div>
  
        {responseMessage && <p className="response-message">{responseMessage}</p>}
      </form>
    </section>
  );
  
  
};

export default Grooming;
